// Auto-split from i18n.js — language: ar
export default {
    translation: {
        // routes & menus
        Dashboard: 'لوحه القياده',
        'Space Data': 'فضاء',
        'Equipment Data': 'معدات',
        'Meter Data': 'متر',
        'Tenant Data': 'مستاجر',
        'Store Data': 'دكان',
        'Shopfloor Data': 'شوب فلور',
        'Combined Equipment Data': 'المعدات المشتركة',
        'Auxiliary System': 'النظام المساعد',
        Microgrid: 'الشبكة المصغرة',
        'Energy Storage Power Station': 'محطة توليد الكهرباء',
        'Photovoltaic Power Station': 'محطة توليد الكهرباء',
        'Fault Alarm': 'إنذار الأعطال',
        Monitoring: 'رصد',
        'Advanced Reporting': 'التقارير المتقدمة',
        'Knowledge Base': 'معارف',
        'Energy Category Data': 'فئة الطاقة',
        'Energy Item Data': 'عنصر الطاقة',
        Carbon: 'انبعاثات ثاني أكسيد الكربون',
        Cost: 'كلف',
        Output: 'الناتج',
        Income: 'دخل',
        Efficiency: 'كفاءة',
        Load: 'حمل',
        Statistics: 'الاحصاءات',
        'Batch Analysis': 'تحليل الدفعات',
        Saving: 'حفظⒺ',
        Plan: 'يخططⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'تتبع المعدات',
        'Equipment Comparison': 'مقارنة المعدات',
        'Shopfloor Comparison': 'مقارنة المعدات',
        'Store Comparison': 'مقارنة المعدات',
        'Space Comparison': 'مقارنة المعدات',
        'Combined Equipment Comparison': 'مقارنة المعدات',
        'Tenant Comparison': 'مقارنة المستأجرين',
        'Environment Monitor': 'مراقب البيئة',
        'Meter Energy': 'طاقة المتر',
        'Meter Prediction': 'تنبؤ العدادⒺ',
        'Virtual Meter Prediction': 'تنبؤ العداد الافتراضيⒺ',
        'Offline Meter Prediction': 'تنبؤ العداد غير المتصلⒺ',
        'Meter Carbon': 'متر انبعاثات ثاني أكسيد الكربون',
        'Meter Cost': 'تكلفة المتر',
        'Meter Trend': 'متر الاتجاه',
        'Meter Realtime': 'متر الوقت الحقيقي',
        'Meter Saving': 'توفير العدادⒺ',
        'Meter Plan': 'خطة العدادⒺ',
        'Master Meter Submeters Balance': 'ماستر ميتر عدادات فرعية الرصيد',
        'Meter Batch Analysis': 'تحليل دفعة العدادات',
        'Meter Comparison': 'مقارنة العدادات',
        'Meter Tracking': 'تتبع العداد',
        'Virtual Meter Saving': 'توفير العداد الافتراضيⒺ',
        'Virtual Meter Plan': 'خطة العدادات الافتراضيةⒺ',
        'Virtual Meter Energy': 'طاقة العداد الافتراضي',
        'Virtual Meter Carbon': 'صك الظاهري انبعاثات ثاني أكسيد الكربون',
        'Virtual Meter Cost': 'تكلفة العداد الافتراضي',
        'Virtual Meter Batch Analysis': 'تحليل دفعة العدادات الافتراضية',
        'Virtual Meter Comparison': "مقارنة العدادات الافتراضية",
        'Offline Meter Energy': 'طاقة العداد غير المتصل بالإنترنت',
        'Offline Meter Carbon': 'انبعاثات ثاني أكسيد الكربون من خط الصك',
        'Offline Meter Cost': 'تكلفة العداد غير متصل',
        'Offline Meter Batch Analysis': 'تحليل دفعة متر غير متصل',
        'Offline Meter Saving': 'توفير عداد دون اتصالⒺ',
        'Offline Meter Plan': 'خطة متر دون اتصالⒺ',
        'Offline Meter Input': 'إدخال عداد غير متصل',
        'Tenant Bill': 'فاتورة المستأجر',
        'Energy Flow Diagram': 'مخطط تدفق الطاقة',
        'Distribution System': 'نظام التوزيع',
        'SVG System': 'نظام التصور SCADA',
        'Faults Data': 'اخطاء',
        'Space Equipments': 'معدات الفضاء',
        'Combined Equipments': 'المعدات المشتركة',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'إجمالي عدد أوامر العمل',
        'Number of New Work Orders': 'عدد أوامر العمل الجديدة',
        'Number of Inprogress Work Orders': 'عدد أوامر العمل قيد التنفيذ',
        'Number of Done Work Orders': 'عدد أوامر العمل المنجزة',
        'Fuel Indicator': 'استهلاك الوقود',
        'Charge Energy Indicator': 'طاقة الشحن',
        'Discharge Energy Indicator': 'طاقة التفريغ',
        'Charge Cost Indicator': 'تكلفة الشحن',
        'Discharge Revenue Indicator': 'إيرادات التفريغ',
        'HVAC': 'HVAC',
        'Fire Control': 'مكافحة الحرائق',
        'Store Dashboard': 'لوحة تحكم المتاجر',
        'Comprehensive overview of store energy performance': 'نظرة شاملة على أداء الطاقة في المتاجر',
        'Total Stores': 'إجمالي المتاجر',
        'Total Area': 'المساحة الإجمالية',
        'Active Meters': 'العدادات النشطة',
        'Active Alerts': 'التنبيهات النشطة',
        'Total Energy Consumption': 'إجمالي استهلاك الطاقة',
        'Carbon Emissions': 'انبعاثات الكربون',
        'Current Period': 'الفترة الحالية',
        'Energy Consumption by Category': 'استهلاك الطاقة حسب الفئة',
        'Cost Distribution by Category': 'توزيع التكاليف حسب الفئة',
        'Monthly Energy & Cost Trends': 'اتجاهات الطاقة والتكاليف الشهرية',
        'Top 5 Energy Consuming Stores': 'أعلى 5 متاجر استهلاكاً للطاقة',
        'Energy Category Details': 'تفاصيل فئات الطاقة',
        'Store Performance Overview': 'نظرة عامة على أداء المتاجر',
        'YoY Change': 'التغيير السنوي',
        'Per m²': 'لكل متر مربع',
        'Usage Intensity': 'كثافة الاستخدام',
        'Dashboard data loaded successfully': 'تم تحميل بيانات لوحة التحكم بنجاح',
        'Failed to load dashboard data': 'فشل في تحميل بيانات لوحة التحكم',
        'Store Name': 'اسم المتجر',
        'Store Area': 'مساحة المتجر',
        'Energy Consumption': 'استهلاك الطاقة',
        'Consumption': 'الاستهلاك',
        'last period': 'الفترة السابقة',
        // Tenant Dashboard
        'Tenant Dashboard': 'لوحة تحكم المستأجرين',
        'Comprehensive overview of tenant energy performance': 'نظرة شاملة على أداء الطاقة للمستأجرين',
        'Total Tenants': 'إجمالي المستأجرين',
        'Tenant Performance Overview': 'نظرة عامة على أداء المستأجرين',
        'Tenant Name': 'اسم المستأجر',
        'Tenant Area': 'مساحة المستأجر',
        'Tenant Type': 'نوع المستأجر',
        // Equipment Dashboard
        'Equipment Dashboard': 'لوحة تحكم المعدات',
        'Total Equipments': 'إجمالي المعدات',
        'Equipment Performance Overview': 'نظرة عامة على أداء المعدات',
        'Equipment Name': 'اسم المعدة',
        'Equipment Type': 'نوع المعدة',
        'Total Energy': 'إجمالي الطاقة',
        'Total Sensors': 'إجمالي المستشعرات',
        'Increment Rate': 'معدل الزيادة',
        // Shopfloor Dashboard
        'Total Shopfloors': 'إجمالي ورش العمل',
        'Shopfloor Performance Overview': 'نظرة عامة على أداء ورش العمل',
        'Shopfloor Name': 'اسم ورشة العمل',
        'Shopfloor Area': 'مساحة ورشة العمل',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'إجمالي المعدات المشتركة',
        'Combined Equipment Performance Overview': 'نظرة عامة على أداء المعدات المشتركة',
        'Combined Equipment Name': 'اسم المعدات المشتركة',
        'Associated Equipments': 'المعدات المرتبطة',

        // Dashboard
        'Welcome to QiXuan': 'مرحبا بكم في QiXuan',
        'An Industry Leading Energy Management System': 'نظام إدارة طاقة رائد في الصناعة',
        "This Year's Consumption CATEGORY VALUE UNIT": 'استهلاك هذا العام {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'تكاليف هذا العام {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'استهلاك هذا الشهر {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'تكاليف هذا الشهر {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'استهلاك {{CATEGORY}} {{VALUE}} {{UNIT}} في نفس الفترة من العام الماضي',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'تكاليف {{CATEGORY}} {{VALUE}} {{UNIT}} في نفس الفترة من العام الماضي',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} استهلاك {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} تكاليف {{UNIT}}',
        // Entities
        Space: 'فضاء',
        Equipment: 'معدات',
        Meter: 'متر',
        'Offline Meter': 'عداد غير متصل',
        'Virtual Meter': 'العداد الافتراضي',
        Tenant: 'مستاجر',
        Store: 'دكان',
        Shopfloor: 'شوب فلور',
        'Combined Equipment': 'المعدات المشتركة',
        'Cost Center': 'مركز التكلفة',
        Name: 'اسم',
        DisplayName: 'اسم العرض',
        UserName: 'اسم المستخدم',
        Description: 'وصف',
        'Energy Category': 'فئة الطاقة',
        'Child Spaces': 'مساحات الأطفال',
        'Associated Equipment': 'المعدات المرتبطة',
        //Energy Categories
        Electricity: 'كهرباء',
        Water: 'الماء',
        'Natural Gas': 'الغاز الطبيعي',
        // SidePanelModal
        Settings: 'اعدادات',
        'Set your own customized style': 'حدد أسلوبك المخصص',
        'Color Scheme': 'نظام الألوان',
        'Choose the perfect color mode for your app': 'اختر وضع الألوان المثالي لتطبيقك',
        Light: 'ضوء',
        Dark: 'داكن',
        'RTL Mode': 'وضع RTL',
        'Switch your language direction': 'تبديل اتجاه اللغة',
        'Fluid Layout': 'تخطيط السوائل',
        'Toggle container layout system': 'تبديل نظام تخطيط الحاوية',
        'Navigation Position': 'موقف الملاحة',
        'Vertical': 'عمودي',
        'Top': 'توب .',
        'Combo': 'كومبو',
        'Transparent': 'شفاف',
        'Inverted': 'معكوس',
        'Card': 'بطاقة',
        'Vibrant': 'حيوي',
        'Select a suitable navigation system for your web application': 'حدد نظام ملاحة مناسب لتطبيق الويب الخاص بك',
        'Vertical Nav': 'التنقل العمودي',
        'Top Nav': 'توب ناف',
        'Vertical Navbar Style': 'نمط شريط التنقل العمودي',
        'Switch between styles for your vertical navbar': 'التبديل بين الأنماط لشريط التنقل العمودي',
        Language: 'اللغة',
        'Switch between languages': 'التبديل بين اللغات',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'أعجبك ما تراه?',
        'Get QiXuan now': 'احصل على QiXuan الآن',
        Purchase: 'الطبعة المؤسسة',
        ContactInfo: 'معلومات الاتصال',
        ProductWebsite: 'الموقع الرسمي للمنتج',
        CompanyWebsite: 'الموقع الرسمي للشركة',
        SalesPhone: 'هاتف المبيعات',
        // Query Panel
        'Base Period Begins': 'تبدأ فترة الأساس',
        'Base Period Ends': 'تنتهي فترة الأساس',
        'Comparison Types': 'أنواع المقارنة',
        'Year-Over-Year': 'على أساس سنوي',
        'Month-On-Month': 'على أساس شهري',
        'Free Comparison': 'مقارنة مجانية',
        'None Comparison': 'لا شيء مقارنة',
        'Reporting Period Begins': 'بدء الفترة المشمولة بالتقرير',
        'Reporting Period Ends': 'انتهاء الفترة المشمولة بالتقرير',
        '(Optional)': '(اختياري)',
        'Period Types': 'أنواع الدورة الشهرية',
        Yearly: 'السنويه',
        Monthly: 'شهري',
        Weekly: 'أسبوعي',
        Daily: 'يومي',
        Hourly: 'الساعه',
        Submit: 'إرسال',
        'Input Energy Category': 'فئة طاقة المدخلات',
        'Output Energy Category': 'فئة الطاقة الناتجة',
        'Fraction Parameter': 'معلمة الكسر',
        Search: 'بحث',
        //DateRangePicker
        sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'موافق',
        today: 'اليوم',
        yesterday: 'أمس',
        hours: 'الساعات',
        minutes: 'محضر',
        seconds: 'الثواني',
        last7Days: 'آخر 7 أيام',
        tomorrow: 'غداً',
        dayAfterTomorrow: 'بعد غد',
        next7Days: 'الأيام السبعة القادمة',
        'Select Date Range': 'حدد النطاق الزمني',
        //Card Summaries and Line Charts
        'Base Period': 'فترة الأساس',
        'Reporting Period': 'الفترة المشمولة بالتقرير',
        'Per Unit Area': 'لكل وحدة مساحة',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'لكل وحدة إنتاج',
        Baseline: 'الاساس',
        Actual: 'حقيقي',
        'Baseline Value - Actual Value': 'خط الأساس - الفعلي',
        'Average Load': 'متوسط الحمولة',
        'Maximum Load': 'الحمولة القصوى',
        'Load Factor': 'عامل الحمولة',
        'Ratio of Average Load to Maximum Load': 'نسبة متوسط الحمولة إلى الحمولة القصوى',
        'Carbon Dioxide Emissions by Energy Category': 'انبعاثات ثاني أكسيد الكربون حسب فئة الطاقة',
        'Costs by Energy Category': 'التكاليف حسب فئة الطاقة',
        'Incomes by Energy Category': 'الدخل حسب فئة الطاقة',
        'Electricity Consumption by Time-Of-Use': 'استهلاك الكهرباء حسب وقت الاستخدام',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'انبعاثات ثاني أكسيد الكربون الكهربائية حسب وقت الاستخدام',
        'Electricity Cost by Time-Of-Use': 'تكلفة الكهرباء حسب وقت الاستخدام',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} الاستهلاك حسب عناصر الطاقة',
        'Ton of Standard Coal by Energy Category': 'طن من الفحم القياسي (TCE) حسب فئة الطاقة',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'طن من انبعاثات ثاني أكسيد الكربون (TCO2E) حسب فئة الطاقة',
        'Reporting Period Consumption CATEGORY UNIT': 'استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'استهلاك فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT':
            'استهلاك الفترة المشمولة بالتقرير {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'استهلاك الفترة المشمولة بالتقرير {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'استهلاك فترة الأساس {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'نسبة مساحة الطفل حسب فئة الطاقة {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'النسبة الإجمالية لمساحة الطفل',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'انبعاثات ثاني أكسيد الكربون في الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'انبعاثات ثاني أكسيد الكربون في الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'انبعاثات ثاني أكسيد الكربون في فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'تكاليف الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'تكاليف الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'تكاليف فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'ناتج فترة التقرير {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} ناتج فترة التقرير {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} ناتج فترة التقرير {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'ناتج فترة التقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'ناتج فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'إيرادات الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'إيرادات الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'إيرادات فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'الفترة المشمولة بالتقرير إجمالي الدخل {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT':
            'الكفاءة التراكمية للفترة المشمولة بالتقرير {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} الكفاءة التراكمية للفترة المشمولة بالتقرير {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} الكفاءة الشاملة التراكمية للفترة المشمولة بالتقرير {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} الكفاءة الشاملة التراكمية للفترة المشمولة بالتقرير {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} فترة الأساس الكفاءة الشاملة التراكمية {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'كفاءة فورية {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} كفاءة فورية {{UNIT}}',
        'Equipment Efficiency Indicator': 'مؤشر كفاءة الطاقة للمعدات',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} كفاءة شاملة فورية {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT':
            'الكفاءة التراكمية للفترة المشمولة بالتقرير {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'الكفاءة التراكمية للفترة المشمولة بالتقرير {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'الكفاءة التراكمية لفترة الأساس {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': 'الكفاءة التراكمية لفترة الأساس {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'فترة الأساس {{CATEGORY}} الحمولة القصوى {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} الحمولة القصوى {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} متوسط الحمولة {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'الفترة المشمولة بالتقرير {{CATEGORY}} عامل الحمولة',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Base Period {{CATEGORY}} متوسط الحمولة {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} متوسط القيمة {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} القيمة القصوى {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} الحد الأدنى للقيمة {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} المتوسط الحسابي {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT':
            'الفترة المشمولة بالتقرير {{CATEGORY}} الوسيط (القيمة المتوسطة) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} عينة الانحراف المعياري {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} تباين العينة {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'توفير الفترة المشمولة بالتقرير {{CATEGORY}} (خط الأساس - الفعلي) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'انخفضت الفترة المشمولة بالتقرير {{CATEGORY}} (خط الأساس - الفعلي) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'توفير الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'توفير فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'الفترة المشمولة بالتقرير استهلاك العداد الرئيسي {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'الفترة المشمولة بالتقرير استهلاك العداد الرئيسي {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'استهلاك العدادات الفرعية للفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'استهلاك العدادات الفرعية للفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'فرق الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'فرق النسبة المئوية للفترة المشمولة بالتقرير',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'فرق الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'قيم الاتجاه',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'قائمة الأعطال',
        'Reporting Period Number of Fault VALUE': 'الفترة المشمولة بالتقرير عدد الأعطال {{VALUE}}',
        'All Faults': 'جميع الأخطاء',
        'Space Faults': 'أخطاء الفضاء',
        'Number of All Faults': 'عدد جميع الأخطاء',
        'Number of Space Faults': 'عدد أخطاء الفضاء',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'طن من الفحم القياسي',
        'Ton of Carbon Dioxide Emissions': 'طن من انبعاثات ثاني أكسيد الكربون',
        'Carbon Emissions Per Unit Of Energy Consumption': 'انبعاثات الكربون لكل وحدة من استهلاك الطاقة',
        'Operating Characteristic Curve': 'عمل منحنى المميزة',
        Tariff: 'تعريف',
        'Detailed Data': 'بيانات مفصلة',
        'Child Spaces Data': 'بيانات المساحات الفرعية',
        'Associated Equipment Data': 'بيانات المعدات المرتبطة',
        'This Year': 'هذا العام',
        'The Same Period Last Year': 'نفس الفترة من العام الماضي',
        'This Month': 'هذا الشهر',
        'This Day': 'هذا اليوم',
        Total: 'مجموع',
        'No data found': 'لم يتم العثور على بيانات',
        Export: 'تصدير',
        'AI Analysis': 'تحليل الذكاء الاصطناعي',
        Datetime: 'التاريخ والوقت',
        'Time-Of-Use Type': 'نوع وقت الاستخدام',
        'Top-Peak': 'توب بيك',
        'On-Peak': 'في أوقات الذروة',
        'Mid-Peak': 'منتصف الذروة',
        'Off-Peak': 'خارج أوقات الذروة',
        'Deep': 'Deep-Valley',
        Percentage: 'النسبه المئويه',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'الاتجاه في الساعة الأخيرة من نقطة قيمة الطاقة',
        Circuit: 'الدائره',
        Point: 'نقطة',
        'Realtime Value': 'القيمة في الوقت الحقيقي',
        //Meter Tracking
        'Meter List': 'قائمة العدادات',
        'Edit Meter': 'حرر',
        'Start Value': 'قيمة البداية',
        'End Value': 'القيمة النهائية',
        'Difference Value': 'قيمة الفرق',
        'Start Integrity Rate': 'معدل النزاهة المبدئي(%)',
        'End Integrity Rate': 'معدل النزاهة النهائي(%)',
        'Full Integrity Rate': 'معدل النزاهة الكامل(%)',
        'Start Integrity Rate Description': 'معدل سلامة البيانات الأولي: نسبة الأجهزة التي تم الحصول بنجاح على قراءة استهلاك الطاقة في لحظة البداية من بين جميع الأجهزة خلال الفترة الإحصائية',
        'End Integrity Rate Description': 'معدل سلامة البيانات النهائي: نسبة الأجهزة التي تم الحصول بنجاح على قراءة استهلاك الطاقة في لحظة النهاية من بين جميع الأجهزة خلال الفترة الإحصائية',
        'Full Integrity Rate Description': 'معدل سلامة البيانات الكامل: نسبة الأجهزة التي تم الحصول بنجاح على قراءة استهلاك الطاقة في لحظة البداية والنهاية معاً من بين جميع الأجهزة خلال الفترة الإحصائية',
        //Equipment Tracking
        'Equipment List': 'قائمة المعدات',
        'Edit Equipment': 'حرر',
        //Profile Dropdown
        Feedback: 'ردود الفعل',
        'Account Settings': 'إعدادات الحساب',
        Logout: 'الخروج',
        //Authentication
        'Log in': 'تسجيل الدخول',
        'Email address': 'عنوان البريد الإلكتروني',
        'Phone Number': 'رقم الهاتف',
        Password: 'شعار',
        CaptchaCode: 'كلمة التحقق',
        Refresh: 'تحديث',
        'Remember me': 'تذكرني',
        'Logged in as ': 'تم تسجيل الدخول باسم ',
        'Forgot Password?': 'نسيت كلمة المرور?',
        'Forgot your password?': 'نسيت كلمة المرور?',
        "Enter your email and we'll send you a reset link": 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين',
        "Enter your email and we'll send you a registration link": 'أدخل بريدك الإلكتروني وسنرسل لك رابط التسجيل',
        'Reset Password': 'إعادة تعيين كلمة المرور',
        'Thanks for using QiXuan!': 'شكرا لاستخدام QiXuan!',
        'You are now successfully signed out': 'لقد قمت الآن بتسجيل الخروج بنجاح',
        'Return to Login': 'العودة إلى تسجيل الدخول',
        'Please check your email!': 'يرجى التحقق من بريدك الإلكتروني!',
        'An email has been sent to ': 'تم إرسال بريد إلكتروني إلى ',
        'Please click on the included link to reset your password':
            'يرجى النقر على الرابط المرفق لإعادة تعيين كلمة المرور الخاصة بك',
        'Please click on the included link to register your account': 'يرجى النقر على الرابط المرفق لتسجيل حسابك',
        'An email with password reset link is sent to ':
            'يتم إرسال بريد إلكتروني يحتوي على رابط إعادة تعيين كلمة المرور إلى ',
        'Change Password': 'تغيير كلمة المرور',
        'Old Password': 'كلمة المرور القديمة',
        'New Password': 'كلمة مرور جديدة',
        'Confirm Password': 'تأكيد كلمة المرور',
        'Update Password': 'تحديث كلمة المرور',
        'Password has been changed!': 'تم تغيير كلمة المرور!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
            'تم إرسال رمز التحقق إلى صندوق الوارد الخاص بك. \
  يرجى نسخه إلى مربع الإدخال أدناه.',
        'New to QiXuan': 'جديد في QiXuan',
        'Create an account': 'إنشاء حساب',
        'EMAIL Account registration successful': '{{EMAIL}} تم تسجيل الحساب بنجاح',
        'Thanks for verifying your account!': 'شكرا للتحقق من حسابك!',
        'Your code is': 'الرمز الخاص بك هو',
        'Send verification code': 'إرسال رمز التحقق',
        'Please wait for NUMBER seconds': 'يرجى الانتظار {{NUMBER}} الثواني',
        'Password reset': 'إعادة تعيين كلمة المرور',
        'Please wait for approval': 'يرجى انتظار الموافقة',
        //notification
        Notifications: 'الاخطارات',
        'Mark all as read': 'وضع علامة مقروءة على الكل',
        'View all': 'كل',
        'Notification New': 'الجديد',
        'Notification Earlier': 'أسبق',
        'Notification List': 'قائمة الإشعارات',
        'Bulk actions': 'الإجراءات المجمعة',
        'Notification Subject': 'موضوع',
        'Notification Created Datetime': 'تاريخ الإنشاء',
        'Notification Priority': 'أولوية',
        'Notification Message': 'رسالة',
        'Notification Status': 'حالة',
        'Notification Mark As Read': 'وضع علامة كمقروءة',
        'Notification Mark As Acknowledged': 'اعترف',
        'Notification Low': 'منخفض',
        'Notification Medium': 'Medium',
        'Notification High': 'عال',
        'Notification Critical': 'حرج',
        'Notification Unread': 'غير مقروء',
        'Notification Read': 'قرأ',
        'Notification Acknowledged': 'اعترف',
        'Notification Archive': 'أرشيف',
        'Notification Delete': 'حذف',
        'Notification Apply': 'طبق',
        'Notification Start Datetime': 'بدء التاريخ والوقت',
        'Notification End Datetime': 'تاريخ الانتهاء',
        'Notification Update Datetime': 'تحديث التاريخ والوقت',
        //Monitoring
        'Run Commands': 'تشغيل الأوامر',
        'Pin Code': 'الرمز البريدي',
        'Unlock': 'فتح',
        'Set Value': 'تعيين القيمة',
        'Fault Alarms': 'إنذارات الأعطال',
        'Instantaneous Efficiency VALUE UNIT': 'كفاءة فورية {{VALUE}} {{UNIT}}',
        'Communication Online': 'عبر الإنترنت',
        'Communication Offline': 'دون اتصال',
        'Equipment Status': 'حالة الجهاز',
        'Equipment Running': 'تشغيل',
        'Equipment Stopped': 'توقف',
        'Show Up to': 'احضر إلى',
        All: 'كل',
        'FROM - TO of TOTAL': '{{FROM}} - {{TO}} من {{TOTAL}} المعدات',
        //Microgrid
        'Microgrid Energy': 'طاقة الشبكة الصغيرة',
        'Microgrid Revenue': 'إيرادات الشبكة الصغيرة',
        'Microgrid Carbon': 'كربون الشبكة الصغيرة',
        'Photovoltaic Generation': 'الجيل الكهروضوئي',
        'EV Charger Consumption': 'استهلاك شواحن السيارات الكهربائية',
        'Load Consumption': 'استهلاك الحمل',
        'Grid Buy': 'شراء من الشبكة',
        'Grid Sell': 'بيع للشبكة',
        'EV Charger': 'شاحن السيارة الكهربائية',
        'Heat Pump': 'مضخة الحرارة',
        'Photovoltaic': 'الطاقة الكهروضوئية',
        'PCS Run State': 'جهاز الدولة',
        'PCS Unknown': 'غير معروف',
        'PCS Initializing': 'تهيئة',
        'PCS Standby': 'المواد الاحتياطية',
        'PCS Shutdown': 'توقف',
        'PCS Fault': 'خطأ',
        'PCS Running': 'تشغيل .',
        'Battery Power': 'طاقة البطارية',
        'Photovoltaic Power': 'الطاقة الضوئية',
        'Grid Power': 'قوة الشبكة',
        'Load Power': 'تحميل السلطة',
        Reporting: 'تقرير .',
        Maintenance: 'الرقم المتسلسل',
        'Serial Number': 'الرقم المتسلسل',
        Address: 'العنوان',
        'Postal Code': 'الرمز البريدي',
        'Rated Capacity': 'تصنيف القدرات',
        'Rated Power': 'تصنيف السلطة',
        Latitude: 'خط العرض',
        Longitude: 'خط الطول',
        'Strategy Management': 'الإدارة الاستراتيجية',
        'Charging Schedule': 'جدول الشحن',
        'Charge Start Time': 'شحن وقت البدء',
        'Charge End Time': 'شحن نهاية الوقت',
        'Discharge Start Time': 'وقت بدء التفريغ',
        'Discharge End Time': 'أداء نهاية الوقت',
        'Total Rated Power': 'إجمالي الطاقة المقدرة',
        'Total Rated Capacity': 'إجمالي السعة المقدرة',
        "Today's Charge": "مبلغ الشحن اليوم",
        "Today's Discharge": "التفريغ اليوم",
        "Today's Generation": "توليد الطاقة اليوم",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'القيمة الاجمالية',
        'Total Discharge': 'التفريغ الكلي',
        'Total Generation': 'الجيل الإجمالي',
        'Total Revenue': 'إجمالي الإيرادات',
        'Total Photovoltaic Generation': 'إجمالي الجيل الكهروضوئي',
        'Total EV Charger Consumption': 'إجمالي استهلاك شاحن EV',
        'Total Load Consumption': 'إجمالي استهلاك الحمل',
        'Total Grid Buy': 'إجمالي الشراء من الشبكة',
        'Total Grid Sell': 'إجمالي البيع للشبكة',
        'Total Efficiency': 'الكفاءة الكلية',
        'Discharge Achievement Rate': 'معدل إنجاز التفريغ',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'تصنيف الإيرادات',
        'Efficiency Ranking': 'تصنيف الكفاءة',
        'Charge Ranking': 'تصنيف توليد الطاقة',
        'Discharge Ranking': 'تصنيف التفريغ',
        'Number of Microgrids': 'عدد الشبكات الصغيرة',
        'Number of Power Stations': 'عدد محطات الطاقة',
        'Microgrid List': 'قائمة ميكروغريد',
        'Select Microgrid': 'اختر ميكروغريد',
        'Previous Page': 'الصفحة السابقة',
        'Next Page': 'الصفحة التالية',
        '7 Days': '7 أيام',
        'Charge UNIT': 'تكلفة {{UNIT}}',
        'Discharge UNIT': 'تسريح {{UNIT}}',
        'Generation UNIT': 'توليد الكهرباء {{UNIT}}',
        'Energy Indicator': 'الطاقة',
        'Revenue Indicator': 'دخل',
        'Carbon Indicator': 'كربون',

        // Energy Storage Power Station
        'Battery Operating State': 'حالة البطارية',
        'Battery State': 'حالة البطارية',
        'Battery Unknown': 'غير معروف',
        'Battery Stopped': 'توقف',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'خطأ', // 1
        'Battery Warning': 'حذر', // 2
        'Battery Standby': 'المواد الاحتياطية', // 3
        'Battery Prohibit DisCharging': 'تعطيل إلغاء', // 4
        'Battery Prohibit Charging': 'حظر شحن', // 5
        'Battery Normal': 'نموذجي', // 6
        'Battery Charging': 'شحن', // 7
        'Battery Discharging': 'في التفريغ', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'مراحل دورة الحياة',
        'Use Phase': 'استخدام المرحلة',
        'Commissioning Phase': 'مرحلة التصحيح',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'مرحلة التثبيت',
        'Device Status': 'حالة الجهاز',
        'Basic Information': 'المعلومات الأساسية',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'العاكسون',
        'Invertor Run State': 'جهاز الدولة',
        'Invertor Unknown': 'غير معروف',
        'Invertor Initializing': 'تهيئة',
        'Invertor Standby': 'المواد الاحتياطية',
        'Invertor Shutdown': 'توقف',
        'Invertor Fault': 'خطأ',
        'Invertor Running': 'تشغيل .',

        //Advanced Reporting & Knowledge base
        'Created Datetime': 'تاريخ الإنشاء',
        'File Format': 'تنسيق الملف',
        'File Size': 'حجم الملف',
        Uploader: 'رافع',
        //Error
        "The page you're looking for is not found": 'لم يتم العثور على الصفحة التي تبحث عنها',
        "Make sure the address is correct and that the page hasn't moved. ": 'تأكد من صحة العنوان وعدم نقل الصفحة. ',
        'If you think this is a mistake,': 'إذا كنت تعتقد أن هذا خطأ,',
        'contact us': 'اتصل بنا',
        'Take me home': 'خذني إلى المنزل',
        'Whoops, something went wrong!': 'عذرا ، حدث خطأ ما!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'حاول تحديث الصفحة، أو الرجوع ومحاولة اتخاذ الإجراء مرة أخرى. ',
        'If this problem persists,': 'إذا استمرت هذه المشكلة,',
        'Captcha Error': 'خطأ كلمة التحقق',
        'Confirm Password Error': 'تأكيد كلمة المرور غير متطابق',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'يبدو أنك نقرت \
على رابط إعادة تعيين كلمة المرور غير صالح. يرجى المحاولة مرة أخرى.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'يبدو أنك نقرت \
على رابط حساب تسجيل غير صالح. يرجى المحاولة مرة أخرى.',
        //Tenant Bill
        'Lease Contract Number': 'رقم عقد الإيجار',
        Download: 'تحميل',
        Print: 'طبع',
        'Payment Notice': 'إشعار الدفع',
        'Bill To': 'بيل إلى',
        'Bill Number': 'رقم الفاتورة',
        'Bill Date': 'تاريخ الفاتورة',
        'Payment Due Date': 'تاريخ استحقاق الدفع',
        'Amount Payable': 'المبلغ المستحق الدفع',
        'Billing Period Start': 'بدء فترة الفوترة',
        'Billing Period End': 'نهاية فترة الفوترة',
        Quantity: 'كم',
        Price: 'ثمن',
        Unit: 'وحدة',
        Amount: 'مبلغ',
        Subtotal: 'المجموع الفرعي',
        'VAT Output Tax': 'ضريبة مخرجات ضريبة القيمة المضافة',
        'Total Amount Payable': 'إجمالي المبلغ المستحق الدفع',
        'Please make sure to pay on or before the payment due date above':
            'يرجى التأكد من الدفع في أو قبل تاريخ استحقاق الدفع أعلاه',
        'Send money to the following account': 'إرسال الأموال إلى الحساب التالي',
        'Account Name': 'اسم الحساب',
        'Bank Name': 'اسم البنك',
        'Bank Address': 'عنوان البنك',
        'RMB Account': 'حساب الرنمينبي',
        // button
        'Toggle Navigation': 'تبديل التنقل',
        // working calendar
        'Working Days': 'أيام العمل',
        'Non Working Days': 'أيام العطلة',
        'Select Row': 'الرجاء اختيار صف البيانات',
        // Offline Meter Input
        'Daily Value': 'القيمة اليومية',
        Date: 'تاريخ',
        'Successfully Saved': 'تم الحفظ بنجاح',
        'Previous Data Is Empty': 'البيانات السابقة فارغة',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact id',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid fdd code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
        'API.INVALID_MENU_ID': 'Invalid menu id',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter id',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter uuid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point id',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule id',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor id',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
        'API.INVALID_SPACE_ID': 'Invalid space id',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space uuid',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store id',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store uuid',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff id',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant id',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user id',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user uuid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.INVALID_OFFLINE_METER_VALUE': 'قيمة عداد غير متصل غير صالحة',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'New password is the same as the old password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'مع الظاهري محطة توليد الكهرباء',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: 'جدول موجز',
        SubMeter: 'تقسيم الجدول',
        'Power Quality': 'Chất lượng điện năng',
        'About Power Quality': 'Giới thiệu về chất lượng điện năng',
        Category: 'Danh mục',
        Type: 'Loại',
        Limit: 'Giới hạn',
        'Normal Limit': 'Giới hạn bình thường',
        'Severe Limit': 'Giới hạn nghiêm trọng',
        Compliance: 'Tỷ lệ tuân thủ',
        'Worst Deviation': 'Độ lệch lớn nhất',
        'Worst Time': 'Thời điểm lệch lớn nhất',
        'Severe Exceed Count': 'Số lần vượt nghiêm trọng',
        'Worst Unbalance': 'Mất cân bằng lớn nhất',
        Hz: 'Hz',
        voltage: 'الجهد',
        current: 'التيار',
        frequency: 'التردد',
        voltage_deviation: 'انحراف الجهد',
        current_unbalance: 'عدم توازن التيار',
        voltage_unbalance: 'عدم توازن الجهد',
        mean_deviation_pct: 'متوسط الانحراف (%)',
        p95_abs_deviation_pct: 'انحراف مطلق P95 (%)',
        mean_abs_deviation_hz: 'متوسط الانحراف المطلق (هرتز)',
        p95_abs_deviation_hz: 'انحراف مطلق P95 (هرتز)',
        mean_unbalance_pct: 'متوسط عدم التوازن (%)',
        p95_unbalance_pct: 'عدم التوازن P95 (%)',
        count: 'العدد',
        min: 'الحد الأدنى',
        max: 'الحد الأقصى',
        mean: 'المتوسط',
        std: 'الانحراف المعياري',
        p5: 'P5',
        p95: 'P95'
    }
};
